import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'constants/routes.constant';

import Page from '../../components/page/Page';
import PageWrapper from '../../components/pageWrapper/PageWrapper';

import RealityGamesLogo from '../../assets/logos/reality-metaverse-logo.png';

import styles from './About.module.scss';
import AboutBanner from './aboutBanner/AboutBanner';
import AboutCollectionSection from './aboutCollectionSection/AboutCollectionSection';
import AboutCreatorsPartnersSection from './aboutCreatorsPartnersSection/AboutCreatorsPartnersSection';
import AboutCreatorsSection from './aboutCreatorsSection/AboutCreatorsSection';
import AboutLandmarksSection from './aboutLandmarksSection/AboutLandmarksSection';
import AboutMainSection from './aboutMainSection/AboutMainSection';
import AboutOurTokenSection from './aboutOurTokenSection/AboutOurTokenSection';
import AboutPartnersSection from './aboutPartnersSection/AboutPartnersSection';
import AboutPlayersSection from './aboutPlayersSection/AboutPlayersSection';
import AboutRoyaltiesDistributionSection from './aboutRoyaltiesDistributionSection/AboutRoyaltiesDistributionSection';
import AboutRoyaltiesPlayersSection from './aboutRoyaltiesPlayersSection/AboutRoyaltiesPlayersSection';
import AboutRoyaltiesSection from './aboutRoyaltiesSection/AboutRoyaltiesSection';
import AboutSocialMediaSection from './aboutSocialMediaSection/AboutSocialMediaSection';
import AboutTokenRoyaltiesSection from './aboutTokenRoyaltiesSection/AboutTokenRoyaltiesSection';
import AboutVideosCollectionsSection from './aboutVideosCollectionsSection/AboutVideosCollectionsSection';
import AboutVideosSection from './aboutVideosSection/AboutVideosSection';

const About = () => {
  const navigate = useNavigate();
  const [isBannerInitialized, setIsBannerInitialized] = useState<boolean>(false);

  return (
    <Page hideLoader withScrollbar>
      <PageWrapper>
        <div className={styles['content']}>
          <AboutBanner onInitialized={() => setIsBannerInitialized(true)} />
          <div className={styles['sections']}>
            <AboutMainSection />
            <AboutLandmarksSection />

            <AboutRoyaltiesPlayersSection>
              <AboutRoyaltiesSection mainAnimationLoaded={isBannerInitialized} />
              <AboutPlayersSection mainAnimationLoaded={isBannerInitialized} />
            </AboutRoyaltiesPlayersSection>

            <AboutVideosCollectionsSection>
              <AboutVideosSection />
              <AboutCollectionSection mainAnimationLoaded={isBannerInitialized} />
            </AboutVideosCollectionsSection>

            <AboutTokenRoyaltiesSection>
              <AboutOurTokenSection mainAnimationLoaded={isBannerInitialized} />
              <AboutRoyaltiesDistributionSection mainAnimationLoaded={isBannerInitialized} />
            </AboutTokenRoyaltiesSection>

            <AboutSocialMediaSection />

            <AboutCreatorsPartnersSection>
              <AboutCreatorsSection />
              <AboutPartnersSection />
            </AboutCreatorsPartnersSection>

            <div className={styles['footer']}>
              <p>
                Check the NFTs at
                <button
                  className={`scale-in-hover ${styles['nft-portal-link']}`}
                  onClick={() => navigate(ROUTES.PORTAL)}
                >
                  NFT PORTAL
                </button>
              </p>
              <a href="https://reality.co/">
                <img className="scale-in-hover" src={RealityGamesLogo} alt="Reality Metaverse" />
              </a>
            </div>
          </div>
        </div>
      </PageWrapper>
    </Page>
  );
};

export default About;
